import { render, staticRenderFns } from "./r-pagination.vue?vue&type=template&id=7f54c23e&shadow"
import script from "./r-pagination.vue?vue&type=script&lang=js&shadow"
export * from "./r-pagination.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports